import type { ReactNode, RefObject } from "react";

type FileUploadProps = {
  inputRef: RefObject<HTMLInputElement | null>;
  onFiles: (files: string[]) => void;
  children: ReactNode;
};

export function FileUpload({ inputRef, onFiles, children }: FileUploadProps) {
  return (
    <>
      {children}
      <input
        ref={inputRef}
        className="visually-hidden"
        type="file"
        multiple
        onChange={(event) => {
          onFiles(Array.from(event.target.files ?? []).map((file) => file.name));
        }}
      />
    </>
  );
}
